import Vue from 'vue'
import router from './router'
import store from './store'

import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import notification from 'ant-design-vue/es/notification'
import { ACCESS_TOKEN } from '@/store/mutation-types'

NProgress.configure({ showSpinner: false }) // NProgress Configuration

const whiteList = ['login', 'register', 'registerResult'] // no redirect whitelist

router.beforeEach((to, from, next) => {
  NProgress.start() // start progress bar

  if (Vue.ls.get(ACCESS_TOKEN)) {
    /* has token */
    if (to.path === '/user/login') {
      next({ path: '/dashboard' })
      NProgress.done()
    } else {
      console.log(to.path, 'to.path', store.getters.roles)
      if (store.getters.roles.length === 0) {
        store
          .dispatch('GetInfo')
          .then(res => {
            const permissions = res.data && res.data.permissions
            store.dispatch('GenerateRoutes', { permissions }).then(() => {
              // 根据roles权限生成可访问的路由表
              // 动态添加可访问路由表
              router.addRoutes(store.getters.addRouters)
              // 确定跳转目标
              let redirect = decodeURIComponent(from.query.redirect || to.path)

              // 判断权限级别
              const perms = permissions || []
              const hasCompany = perms.includes('online-company')
              const hasProject = perms.includes('online-first')
              const permCount = perms.length

              const isTotal = hasCompany && hasProject && permCount > 2
              const isMedium = hasCompany && hasProject && permCount === 2
              const isSmall = !hasCompany && hasProject

              // 跳转逻辑
              if (isSmall) {
                // 小权限：永远去 project
                redirect = '/activePlatForm/project'
              } else if (isMedium) {
                // 中权限：根路径或无权访问的路径去 company，否则去 redirect
                if (redirect === '/' || !['/activePlatForm/company', '/activePlatForm/project'].includes(redirect)) {
                  redirect = '/activePlatForm/company'
                }
                // 否则保持原 redirect（company 或 project）
              } else if (isTotal) {
                // 总权限：根路径去 dashboard，否则去 redirect
                if (redirect === '/') {
                  redirect = '/dashboard'
                }
                // 否则保持原 redirect
              } else {
                // 无权限兜底
                redirect = '/dashboard'
              }

              if (to.path === redirect) {
                // hack方法 确保addRoutes已完成 ,set the replace: true so the navigation will not leave a history record
                next({ ...to, replace: true })
              } else {
                // 跳转到目的路由
                next({ path: redirect })
              }
            })
            store.dispatch('Connect')
          })
          .catch((err) => {
            console.log(err, 'err')
            notification.error({
              message: '会话过期',
              description: '您的会话信息已失效，请重新登录'
            })
            store.dispatch('Logout').then(() => {
              next({ path: '/user/login', query: { redirect: to.fullPath } })
            })
          })
      } else {
        next()
      }
    }
  } else {
    if (whiteList.includes(to.name)) {
      // 在免登录白名单，直接进入
      next()
    } else {
      next({ path: '/user/login', query: { redirect: to.fullPath } })
      NProgress.done() // if current page is login will not trigger afterEach hook, so manually handle it
    }
  }
})

router.afterEach(() => {
  NProgress.done() // finish progress bar
})

/**
 * Action 权限指令
 * 指令用法：
 *  - 在需要控制 action 级别权限的组件上使用 v-action:[method] , 如下：
 *    <i-button v-action:add >添加用户</a-button>
 *    <a-button v-action:delete>删除用户</a-button>
 *    <a v-action:edit @click="edit(record)">修改</a>
 *
 *  - 当前用户没有权限时，组件上使用了该指令则会被隐藏
 *  - 当后台权限跟 pro 提供的模式不同时，只需要针对这里的权限过滤进行修改即可
 *
 *  @see https://github.com/sendya/ant-design-pro-vue/pull/53
 */
const action = Vue.directive('action', {
  bind: function (el, binding, vnode) {
    const actionName = binding.arg
    const roles = store.getters.roles
    const elVal = vnode.context.$route.meta.permission
    const permissionId = elVal instanceof String && [elVal] || elVal
    roles.permissions.forEach(p => {
      if (!permissionId.includes(p.permissionId)) {
        return
      }
      if (p.actionList && !p.actionList.includes(actionName)) {
        el.parentNode && el.parentNode.removeChild(el) || (el.style.display = 'none')
      }
    })
  }
})

export {
  action
}
